<template>
    <section class="final-project">

            <div class="demo-reel-submission">
               
                <dam-submission :type="'demoReel'" :demoReel="latestSubmission"></dam-submission>
                
            </div>
        <div class="panel">
            <div class="panel-heading">
                <h2>Previous Submissions</h2>
            </div>
            <div class="panel-body">
                
                <ul v-if="projects" class="projects">
                    <li v-for="(project, $index) in projects">
                        <div class="table-row">
                            <div><i @click.prevent="selectedProject===project.id?selectedProject=null:selectedProject=project.id" class="fa fa-plus"></i></div>
                            <div>{{project.createdAt | shortDate}}</div>
                            <div>    
                                <img v-if="hasFeedback(project)" class="play active" @click="playFeedback(feedbackUrl(project))" src="../assets/img/play-button-small-green.png">                                    
                                <img v-else class="play" src="../assets/img/play-button-small-grey.png">
                            </div>
                            <div v-if="project.passed == null">                               
                                Waiting For Feedback
                            </div>
                            <div v-if="project.passed === false" class="fixes-needed">
                                Fixes Required
                            </div>
                            <div v-if="project.passed === true" class="passed">
                                Passed
                            </div>                                
                        </div>

                        <div v-if="selectedProject===project.id" class="project">
                           <div class="media">
                                <div class="reel">
                                    <video controls>
                                        <source :src="project.demoReelUrl" />
                                    </video>
                                </div>                                  
                               
                                <ul class="still-renders" v-if="project.stillRenders && project.stillRenders.length > 0">
                                    <li v-for="(render, $index) in project.stillRenders">
                                        <a v-if="render.includes('amazonaws')" :href="render" target="_blank">Image {{$index}}</a>
                                        <a v-else :href="'https://drive.google.com/uc?export=view&id=' + render" target="_blank">Image {{$index}}</a>
                                    </li>
                                    <li><h4 class="bold">Additional Videos</h4></li>
                                    <li v-if="project.extraVideos.length === 0">No additional videos</li>
                                    <li v-for="(asset, $index) in project.extraVideos">
                                        <a :href="asset.url" target="_blank">{{asset.descriptor}}</a>                                        
                                    </li>
                                </ul>

                            </div>
                            

                            <div class="student-comments" v-if="project.comments">
                                 <label>Your Comments</label>
                                {{project.comments}}
                            </div>

                            <div class="feedback-comments" v-if="project.final_feedback && project.final_feedback.comments">
                                <label>Director's Comments</label>
                                {{project.final_feedback.comments}}
                            </div>
                          
                            <div class="feedback-comments" v-if="project.final_feedbacks" v-for="final_feedback in project.final_feedbacks">
                                <div v-if="final_feedback.comments">
                                    <label>Director's Comments</label>
                                    {{final_feedback.comments}}
                                </div>
                            </div>

                            <div class="diploma" v-if="project.passed === true && project.enrollment && project.enrollment.program && project.enrollment.program.venue === 'online'">

                                
                                <div v-if="(localStorage.roles.includes('Student') && localStorage.transitioned != 'true')">
                                    <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'.pdf'" _target="blank">
                                        Digital Credentials (dark)
                                    </a>
                                    <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+localStorage.account_id+'_print.pdf'" _target="blank">
                                        Digital Credentials (light)
                                    </a>                                        
                                    
                                </div>
<!--                                 <button v-if="project.cloudinaryIds && project.cloudinaryIds.length > 0 && !project.postedToGallery" @click.prevent="convertToGallery(project)" class="btn btn-success">Add Submission Images to Gallery</button>
 -->                            </div>
                            <div>
                            </div>
                        </div>
                    </li>
          
                </ul>
            </div>
        <div class="feedback-lightbox" @click="stopFeedback()" v-show="feedbackPlaying===true">
            <i class="fa fa-remove"></i>
            <div class="video-wrapper" @click.stop>
                <video-player ref="videoPlayer" v-show="feedbackPlaying" :options="playerOptions">
                </video-player>
            </div>
        </div>
        </div>
    </section>
</template>
<script>

import axios from 'axios';
import Dropzone from 'vue2-dropzone';
import { videoPlayer } from 'vue-video-player';
import toastr from 'toastr';

import DamSubmission from './reusable/dam-submission/DAMSubmission.vue';

import aws from '../services/aws';
import drive from '../services/google/drive';
import finalProjects from '../services/final-projects';

const uuidV4 = require('uuid/v4');

export default {
    data() {
        return {
            project: {
                thumbnail: null,
                demoReel: null,
                stillRenders: [],
                comments: null,
            },
            latestSubmission: null,
            projects: null,
            selectedProject: null,
            link: null,
            fileRejected: false,
            feedbackPlaying: false,
            playerOptions: {
                start: 0,
                controls: true,
                preload: 'auto',
                autoplay: false,
                fluid: true,
                sources: []
            },
        }
    },
    components: {
        Dropzone, 
        videoPlayer,
        DamSubmission
    },

    async mounted() {
        await this.getProjects();   
        this.$bus.$on('reload_assignment', ()=>{
            this.getProjects(); 
        });
        
        if (this.$route.query.selectedProject)
            this.selectedProject = parseInt(this.$route.query.selectedProject)
    },
    methods: {

            convertToGallery(project) {
                finalProjects.convertToGallery(project)
                this.$store.dispatch('toggle', { type: 'loading', boolean: true });

                project.postedToGallery = true;
                
                finalProjects.convertToGallery(project).then((response) => {
                    this.$store.dispatch('toggle', { type: 'loading', boolean: false });
                    if (response.data.success === true) {
                        toastr.success('Added to gallery');                   
                        this.$router.push('/galleries/' + response.data.gallery.id);

                    } else {
                        toastr.error('Error adding to gallery');
                        project.postedToGallery = false;
                    }
                });
            },
            hasFeedback(project) {
                if (project.final_feedback) {
                    if (project.final_feedback.url && project.final_feedback.url.trim() != '') {
                        return true;
                    }
                }

                if (project.final_feedbacks) {
                    let hasVideo = project.final_feedbacks.find((f)=> { return f.url && f.url.trim() !== ''});
                    if (hasVideo) {
                        return true;
                    }
                }
                return false;
            },
            feedbackUrl(project) {
                if (project.final_feedback) {
                    return project.final_feedback.url;
                }
                if (project.final_feedbacks && project.final_feedbacks.length > 0) {
                     return project.final_feedbacks.find((f)=> { return f.url && f.url.trim() !== ''}).url;
                }
            },
            fileAdded(file,ref) {
                this.fileRejected = false;
                this.$nextTick(()=> {
                    const rejected = this.$refs[ref].getRejectedFiles();
                    if (rejected.length > 0) {
                        this.fileRejected = true;
                    }
                    for (let f of rejected) {
                        this.$refs[ref].removeFile(f);    
                    }                    
                })
            },
            stopFeedback() {
                this.$refs.videoPlayer.player.pause();
                this.feedbackPlaying = false;
            },
            playFeedback(url) {
                var self = this;

                if (url.trim() == '') {
                    toastr.info('No video feedback for this submission');
                    return;
                }

                var filename = url.split('/').pop();

                self.playerOptions.sources = [];

                self.$store.dispatch('toggle', { type: 'loading', boolean: true });

                aws.getPresignedUrl(self, 'ttto-final-feedback', filename, 'getObject', false, 'finalFeedback').then(function(presigned) {
                    self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                    self.playerOptions.sources.push({
                        src: presigned.data,
                        type: 'video/mp4'
                    });
                    self.feedbackPlaying = true;

                }).catch(function(error) {
                    self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                    toastr.error('Error getting feedback video');
                });

            },
        getProjects() {
            var self = this;
            return finalProjects.get().then(function(response) {
                self.projects = response.data.projects.sort(function(a,b) { return new Date(a.createdAt) - new Date(b.createdAt)}).map((p)=>{
                    if (!p.assetImages) {
                        p.assetImages = [];
                    }

                    p.extraVideos = p.assetImages.filter((a) => { 
                        return a.url && a.url.includes('.mp4') && a.url !== p.demoReelUrl;
                    });
                    
                    console.log(p)
                    return p;
                })
                self.latestSubmission = self.projects[self.projects.length - 1];
                self.$forceUpdate();
                return true;
            })
        },
   
    },

}

</script>
<style lang="scss" scoped>

    .diploma a {     
        margin-right:1rem;
    }

    .file-rejected {
        background: red;
        color:#fff;
        padding:1rem;
        text-align:center;
    }
    
    .drive-progress {
        position: fixed;
        top:0;
        left:0;
        width:100%;
        height:4rem;
        border-bottom:1px solid #b0b0b0;
        background:#1c1c1c;
        color:#3cf;
        display:flex;
        align-items:center;
        justify-content:center;
    }
    .intro {
        padding:2rem 2rem 1rem;
    }
    form, .projects {
        padding: 1rem;
    }

    .uploader {
        button {
            margin-right:.5rem;
            & + span {
                position: relative;
                top:1rem;                
            }
        }
        label {
             font-weight:700!important;
        }
    }
    .uploads {
        display:flex;
        .form-group:not(:first-child) p {
            margin-bottom:3.5em;
        }
    
        & > div {
            width:33.33333%;
            padding:1rem;
        }

    }

    .projects li:last-child .table-row {
        border-bottom: 1px solid #b0b0b0!important;
    }

    .table-row {
        display:flex;
        border:1px solid #b0b0b0;
        border-bottom:none;
        .play {
            width:30px;
            height:30px;
            &.active {
                cursor: pointer;
            }
        }
        & > div {
            min-height:100%;
            padding:5px;
            border-right:1px solid #b0b0b0;
            display:flex;
            justify-content:flex-start;
            align-items:center;
        }
        & > div:first-child {
           width:4%;
           text-align:center;
           display:flex;           
           justify-content:center;
           i {
            cursor:pointer;
           }
        }
        & > div:nth-child(2) {
            width:50%;
        }
        & > div:nth-child(3) {
            width:23%;
            display:flex;
            justify-content:center;
        }       
        & > div:nth-child(4) {
            width:24%;
             border-right:none;
        }
    }


    .media {
        border-top:1px solid #b0b0b0;
        display: flex;
        .reel {
            width:75%;
            video {
                width:100%;
            }
        }
        .still-renders {
            padding:1rem;
        }
    }
    
    .student-comments, .feedback-comments {
         padding:2rem;
        label {
            display:block;
            font-weight:700!important;
        }
    }
    div.passed {
        background:#3AC384;
        color:#1a1a1a;
    }
    div.fixes-needed {
        background:#3AB8C4;
        color:#1a1a1a;
    }

    .diploma {
        padding:0 2rem 2rem 2rem;
        p {
            margin-top:1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// FinalProject.vue?259ca114